<div id="navigation-footer" class="d-block d-xs-none">
  <div>
    <span class="build-version inviso-text-black">{{versionInfo}}</span>
  </div>
  <div class="navigation-footer-text row">
    <div class="col-xs-12">
      <a routerLink="/contact">Contact</a>
      <a routerLink="/help">Help</a>
      <a routerLink="/privacyPolicy">Privacy</a>
    </div>
  </div>
  <div class="navigation-footer-text row">
    <div id="navigation-copyright" class="col-xs-12">
      <app-copy-right></app-copy-right>
    </div>
  </div>
</div>
